import React from "react";
import AvailableJobsMainComponent from "../components/AvailableJobs/AvailableJobsMainComponent";

const AvailableJobsPage = () => {
  return <AvailableJobsMainComponent />;
};

export default AvailableJobsPage;